'use strict';

angular.module('myConsultApp')
    .factory('ProvidersService', function ($resource, ENV, Session, $rootScope) {

        var providersService = {};
        
        var chosenProvider = false;

        var chosenSheltar = '';
    
        var chosenVeterinarian = '';
    
        var pagetitle = '';
    
        var saveTarget = '';
   
        var petOwnerZipcode = null;
    
        providersService.setTitle = function(title){
            pagetitle = title; 
        }

         providersService.getTitle = function(){
            return pagetitle;
        }
         
        providersService.setSaveTarget = function(target){
            saveTarget = target; 
        }

         providersService.getSaveTarget = function(){
            return saveTarget;
        }
         
         providersService.setPetownerZipcode = function(zipcode){
            petOwnerZipcode = zipcode;
        }
         
         providersService.getPetownerZipcode = function(){
            return petOwnerZipcode;
        }

        providersService.searchProviders = function (search) {
            $rootScope.loadProviderProcess = true;
            var organizations = $resource(ENV.apiEndpoint + '/1.0/providers/',{},{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});
            console.log();
            return organizations.get(search).$promise.then(function(response) {
                return response;
            });
        };

        providersService.getDefaultOrganization = function () {
            var organization = $resource(ENV.apiEndpoint + '/1.0/default_organization/',{},{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});
            return organization.get().$promise.then(function(response) {
                return response;
            });
        };

        providersService.getProviderPage = function (url) {
            var providers = $resource(url,{},{get:{headers: { 'Authorization': 'Bearer '+ Session.accessToken }}});
            $rootScope.loadProviderProcess = true;
            return providers.get({}).$promise.then(function(response) {
                return response;
            });
        };

        providersService.saveProvider = function (petId, providerData) {

            var organizations = $resource(ENV.apiEndpoint + '/1.0/pets/:petId/providers/primary/',{petId: petId},{ save: { method: 'PUT',headers: { 'Authorization': 'Bearer '+Session.accessToken } }});
            return organizations.save(providerData).$promise.then(function(response) {
                return response;
            });

        };

      providersService.saveProviderShelter = function (petId, providerData,isNew) {

          var organizations;
          if(isNew){
            organizations = $resource(ENV.apiEndpoint + '/1.0/pets/:petId/providers/',{petId: petId},{save:{method: 'POST',headers: { 'Authorization': 'Bearer '+Session.accessToken }}});
          } else {
            organizations = $resource(ENV.apiEndpoint + '/1.0/pets/:petId/providers/shelter/',{petId: petId},{ save: { method: 'PUT',headers: { 'Authorization': 'Bearer '+Session.accessToken } }});
          }

          return organizations.save(providerData).$promise.then(function(response) {
            return response;
          });

      };

        providersService.removePrimaryCareProvider = function (petId) {

            var organizations = $resource(ENV.apiEndpoint + '/1.0/pets/:petId/providers/primary/',{petId: petId},{remove:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

            return organizations.remove().$promise.then(function(response) {
                return response;
            });
        };


        providersService.getPrimaryCareProvider = function (petId) {

            var organizations = $resource(ENV.apiEndpoint + '/1.0/pets/:petId/providers/primary/',{petId: petId},{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

            return organizations.get().$promise.then(function(response) {
                return response.petProvider;
            });
        };

        providersService.getShelterCareProvider = function (petId) {

          var organizations = $resource(ENV.apiEndpoint + '/1.0/pets/:petId/providers/shelter/',{petId: petId},{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

          return organizations.get().$promise.then(function(response) {
            return response.petProvider;
          });
        };


        providersService.getProviderById = function (providerId) {

            var organizations = $resource(ENV.apiEndpoint + '/1.0/providers/:providerId/',{providerId: providerId},{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

            return organizations.get().$promise.then(function(response) {
                return response.organization;
            });
        };
        
        providersService.storeProvider = function (value) {
						chosenProvider = value;
            return;
        };
        
        providersService.getProvider = function () {
            return chosenProvider;
        };
    
    
        providersService.storeSheltar = function (value) {
            chosenSheltar = value;         
          return;
        };
        
        providersService.getSheltar = function () {
            return chosenSheltar;
        };
    
    
      providersService.storeVeterinarian = function (value) {
            chosenVeterinarian = value;
            return;
        };
        
        providersService.getVeterinarian = function () {
            return chosenVeterinarian;
        };

        return providersService;
  });
